module.exports = __webpack_public_path__ + "media/applications/assets/images/size-info/bomber-23a2110f77839cbc4a5970d100a8f63d.png";